import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  { label: 'Consumo', value: 'consumption' },
  { label: 'Tarifa', value: 'service' },
  { label: 'Pagamento', value: 'payment' },
]

export const strategy = optionsToStrategy(options)
